import React from 'react';
import { Globe } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { LANGUAGE_STORAGE_KEY, SUPPORTED_LANGUAGES } from '@/i18n';

// Compact EN/SW language switcher. Lives in the shared Header so it appears in
// every portal (tenant, owner, concierge, admin, super-admin). Persists the
// choice to localStorage and updates <html lang> via the i18n config listener.
export const LanguageSwitcher: React.FC = () => {
  const { i18n, t } = useTranslation();
  const current = (i18n.language || 'en').split('-')[0];
  const value = SUPPORTED_LANGUAGES.includes(current as (typeof SUPPORTED_LANGUAGES)[number])
    ? current
    : 'en';

  const handleChange = (lng: string) => {
    i18n.changeLanguage(lng);
    try {
      localStorage.setItem(LANGUAGE_STORAGE_KEY, lng);
    } catch {
      // localStorage may be unavailable (private mode); language still changes for the session.
    }
  };

  const shortLabel = value === 'sw' ? 'SW' : 'EN';

  return (
    <Select value={value} onValueChange={handleChange}>
      <SelectTrigger className="h-9 w-[78px] text-sm" aria-label={t('language.switch')}>
        <Globe className="w-4 h-4 mr-1 shrink-0 text-blue-600" />
        <span>{shortLabel}</span>
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="en">{t('language.english')}</SelectItem>
        <SelectItem value="sw">{t('language.swahili')}</SelectItem>
      </SelectContent>
    </Select>
  );
};

export default LanguageSwitcher;
